/* eslint-disable eqeqeq */
import {
  Box,
  Container,
  FormControl,
  FormHelperText,
  IconButton,
  Link,
  OutlinedInput,
  ThemeProvider,
  Typography,
} from "@mui/material";
import AppBaseScreen from "../../components/AppBaseScreen";
import { theme } from "./theme";
import { useTranslation } from "react-i18next";
import { Field, Form, Formik } from "formik";
import AppButton from "../../components/AppButton";
import { ContentCopy } from "@mui/icons-material";
import AppShareButton from "../../components/AppShareButton";
import { useDispatch, useSelector } from "react-redux";
import { showMessageBar } from "../../store/actions";
import { MESSAGE_BAR_TYPES } from "../../utils/constants";
import { inviteFriendAPI } from "../../store/api";
import { getReferalSelector } from "../../utils/selectorHelpers";
import { useEffect } from "react";
import { fetchReferalSettings } from "../../store/actions/ReferalActions";

const Refer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const refer = useSelector(getReferalSelector);
  const inititialValue = {
    email: ''
  }
  useEffect(() => {
    dispatch(fetchReferalSettings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      await inviteFriendAPI(values);
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.SUCCESS, 'Invite Sent Successfully!'));
      setSubmitting(false);
      resetForm();
    } catch (err) {
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err));
    }
  }

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(refer?.referLink);
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.SUCCESS, 'URL copied!'))
    } catch (err) {
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, 'Failed to copy - ' + err.message));
    }
  };
  return (
    <AppBaseScreen isHeader={true} showLocale={true} showMenu={false} headerTitle={t('invite.title')} showLogo={false} navigate={true} backText={t('Home')} headerTitleCase={'capitalize'}>

      <ThemeProvider theme={theme}>
        <Container maxWidth='xs' sx={{ paddingTop: 5, paddingLeft: 1, paddingRight: 1 }} disableGutters>
          <Typography fontSize={18} fontWeight={600}>{t('invite.sub1').replace('%refererPayeeReward%', refer?.rewardCurrencySymbol + refer?.refererPayeeReward)
            .replace('%referredPayeeReward%', refer?.rewardCurrencySymbol + refer?.referredPayeeReward)}</Typography>
          <Typography marginTop={2}>{t('invite.sub2').replace('%refererPayeeReward%', refer?.rewardCurrencySymbol + refer?.refererPayeeReward)
            .replace('%referredPayeeReward%', refer?.rewardCurrencySymbol + refer?.referredPayeeReward)}</Typography>
          <Typography marginTop={2}>{t('invite.sub3').replace('%refererPayeeReward%', refer?.rewardCurrencySymbol + refer?.refererPayeeReward)
            .replace('%referredPayeeReward%', refer?.rewardCurrencySymbol + refer?.referredPayeeReward)}</Typography>
          <Formik
            initialValues={inititialValue}
            onSubmit={handleFormSubmit}
            enableReinitialize={true}
            validateOnBlur={true}
            validateOnChange={false}
            validate={async (values) => {
              const errors = {};
              for (const key in values) {
                if (!!values[key]) {
                  if (key === 'email') {
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(values[key])) {
                      errors[key] = 'Invalid email address';
                    }
                  }
                }
              }
              return errors;
            }}
          >
            {({ handleSubmit, isSubmitting, isValid, errors }) => (
              <Form onSubmit={handleSubmit} autoComplete="off" style={{ marginBottom: 20, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <Field name="email">
                  {({ field }) => (
                    <FormControl
                      fullWidth
                      variant="outlined"
                      sx={{ marginTop: 2 }}
                      required
                    >
                      <OutlinedInput
                        {...field}
                        placeholder={t('invite.text.placeholder')}
                        autoComplete="off"
                      />
                    </FormControl>
                  )}
                </Field>
                {errors?.email && <FormHelperText sx={{ textAlign: 'left', width: '100%', color: "#FF9494", fontSize: 12 }}>{errors.email}</FormHelperText>}

                <AppButton
                  type="submit"
                  buttontheme="light"
                  disabled={!isValid || isSubmitting}
                  loading={isSubmitting}
                  title={t('invite.send')}
                  sx={{ marginTop: 2 }}
                />

              </Form>)}
          </Formik>
          <Typography textAlign={'center'} marginTop={2}>{t('OR')}</Typography>
          <Typography marginTop={2}>{t('invite.text.copy')}</Typography>
          <Box>
            <Link sx={{
              display: 'inline-block',
              maxWidth: 260,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              verticalAlign: 'middle'
            }}>{refer?.referLink}</Link>
            <IconButton onClick={handleCopy}>
              <ContentCopy htmlColor="#F8F8F8" />
            </IconButton>
            <AppShareButton title={t('invite.title')} text={t('webshare.caption').replace('%refererPayeeReward%', refer?.rewardCurrencySymbol + refer?.refererPayeeReward)
              .replace('%referredPayeeReward%', refer?.rewardCurrencySymbol + refer?.referredPayeeReward)} url={refer?.referLink} />
          </Box>
        </Container>
      </ThemeProvider>
    </AppBaseScreen>
  );
};

export default Refer;
